import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { GridHttpParams } from '../interfaces/grid-http-params';
import { SiaGridPageRequest } from '../interfaces/sia-grid-page-request';
import { SiaGridPageResponse } from '../interfaces/sia-grid-page-response';
import {
  SiaGridSummary,
  SiaGridSummaryRequest,
} from '../interfaces/sia-grid-summary-request';
@Injectable({
  providedIn: 'root',
})
export class SiaGridApi {
  private siaHttpService = inject(SiaHttpService);

  private readonly _controller: string = 'grid-core';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  loadData(params: SiaGridPageRequest): Promise<SiaGridPageResponse> {
    return this.siaHttpService.post(`${this._controller}/page`, params);
  }

  loadSummary(params: SiaGridSummaryRequest): Promise<SiaGridSummary[]> {
    return this.siaHttpService.post(`${this._controller}/summary`, params);
  }
  loadHeaderFilterData(params: SiaGridPageRequest): Promise<any> {
    return this.siaHttpService.post(
      `${this._controller}/header-filter`,
      params,
    );
  }

  updateRow(gridData: GridHttpParams) {
    return this.siaHttpService.put(`${this._controller}/update`, gridData);
  }

  insertRow(gridData: GridHttpParams): Promise<any> {
    return this.siaHttpService.post(`${this._controller}/insert`, gridData);
  }

  deleteRow(gridId: string, keysData: any) {
    let params = new HttpParams();
    params = params.set('componentId', `${gridId}`);
    params = params.set('jsonData', `${JSON.stringify(keysData)}`);
    return this.siaHttpService.delete(`${this._controller}/delete`, { params });
  }

  massiveDelete(
    gridId: string,
    spName: string,
    keysData: any[],
  ): Promise<boolean> {
    return this.siaHttpService.post(`${this._controller}/massive-delete`, {
      componentId: gridId,
      spName: spName,
      jsonValues: JSON.stringify(keysData),
    });
  }
}
